import { render, staticRenderFns } from "./lab_page.vue?vue&type=template&id=42b1f834&scoped=true"
import script from "./lab_page.vue?vue&type=script&lang=js"
export * from "./lab_page.vue?vue&type=script&lang=js"
import style0 from "./lab_page.vue?vue&type=style&index=0&id=42b1f834&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b1f834",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42b1f834')) {
      api.createRecord('42b1f834', component.options)
    } else {
      api.reload('42b1f834', component.options)
    }
    module.hot.accept("./lab_page.vue?vue&type=template&id=42b1f834&scoped=true", function () {
      api.rerender('42b1f834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/org/lab_page.vue"
export default component.exports